import { useEffect } from 'react'
import ManagerNav from './managernav'
import TrainingStats from './trainingstats'
import { useState, useContext } from 'react'
import CourseViewer from './courseviewer'
import { AuthContext } from '../AuthContext'
import StaffNav from '../staff/staffnav'




  
      
      function classNames(...classes) {
        return classes.filter(Boolean).join(' ')
      }


  
  export default function TrainingHome() {

    const user = useContext(AuthContext); // Access the user state from AuthContext

    // Define tabs based on user access level

    const role = user?.role || ''; // User role for filtering

    
    let tabs = [];

    if (user && user.access === "staff") {
      // Staff users only see Knowledge Tree
      tabs = [
        { name: 'Knowledge Tree', href: '/knowledge-tree', current: true },
      ];
    } else if (user && (user.access === "manager" || user.access === "admin")) {
      // Managers and admins see all tabs
      tabs = [
        { name: 'Document Builder', href: '/trainingdocbuilder', current: true },
        { name: 'Quiz Builder', href: '/quiz-builder', current: false },
        { name: 'Training Stats', href: '/training-stats', current: false },
        { name: 'Knowledge Tree', href: '/knowledge-tree', current: false }
      ];
    }


    const [trainingDocuments, setTrainingDocuments] = useState([]);
    const [start, setStart] = useState(null);

    const token = localStorage.getItem('token');

    useEffect(() => {
      const fetchTrainingDocuments = async () => {
        try {
          const response = await fetch('https://api.insightos.co.uk/api/trainingdocuments', {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
            credentials: 'include',
          });
    
          const response2 = await fetch('https://api.insightos.co.uk/api/trainingresults', {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
            credentials: 'include',

          });
    
          if (!response.ok || !response2.ok) {
            console.error('Failed to fetch training documents or results');
            return;
          }
    
          const trainingData = await response.json();
          const resultsData = await response2.json();
          const trainingResults = resultsData.data; // Extract training results array

          console.log(trainingResults);



          
          // now in trainingResult find the latest .Attempt higher the nimber 
    
          // Transform data: group by TrainingDocName
          const groupedData = trainingData.data.reduce((acc, item) => {
            const { TrainingDocName, Title, Page, Code, id, Role } = item;
    
            if (!acc[TrainingDocName]) {
              acc[TrainingDocName] = { TrainingDocName, Role, Pages: [] };
            }
    
            acc[TrainingDocName].Pages.push({ Title, Page, Code, id });
            return acc;
          }, {});
    
          // Convert grouped object back to an array and sort Pages by Page number
          let groupedArray = Object.values(groupedData).map((group) => ({
            ...group,
            Pages: group.Pages.sort((a, b) => a.Page - b.Page), // Sort Pages by Page number
          }));
    
          // Ensure each training document's first page is matched with TrainingId
          groupedArray = groupedArray.map((doc) => {
            if (doc.Pages.length === 0) return { ...doc, isComplete: false };
    
            const firstPageId = doc.Pages[0].id; // Get first page ID
    
            const matchedResult = trainingResults
            .filter((result) => result.CourseId == firstPageId) // Filter by CourseId
            .sort((a, b) => b.Attempts - a.Attempts) // Sort by Attempts (descending order)
            .shift(); // Get the first result (the latest attempt)
          
          console.log(matchedResult);
          
          return {
            ...doc,
            isComplete: matchedResult?.Completed === 1, // Check if quiz is completed
            score: matchedResult?.Result, // Get the result of the latest attempt
            difficulty: matchedResult?.Difficulty, // Get the difficulty of the latest attempt
            QuestionNumber: matchedResult?.QuestionNumber, // Get the question number from the latest attempt
          };

          });
    
          console.log(groupedArray); // Verify the final merged and sorted data
          setTrainingDocuments(groupedArray);
        } catch (error) {
          console.error('Error:', error);
        }
      };
    
      fetchTrainingDocuments();
    }, [token]); // Add `token` as a dependency if it comes from state/context
    

    console.log(start)

    if (start !== null) {
      return <CourseViewer courseDocName={start} />;
      
    }


console.log(trainingDocuments);

    const normalizeRole = (value = '') => String(value || '').trim().toLowerCase();
    const userRole = normalizeRole(role);
    const myTraining = trainingDocuments.filter((doc) => normalizeRole(doc.Role) === userRole);
    const otherTraining = trainingDocuments.filter((doc) => normalizeRole(doc.Role) !== userRole);

    const renderTrainingCard = (training) => {
      const scorePercentage = training.QuestionNumber
        ? Math.round((training.score / training.QuestionNumber) * 100)
        : 0;
      const isFail = training.isComplete && scorePercentage < 80;

      return (
        <li
          key={training.TrainingDocName}
          className="group relative overflow-hidden rounded-2xl border border-white/20 bg-white/60 shadow-xl backdrop-blur-xl transition-all hover:shadow-2xl"
        >
          <div className="absolute inset-0 bg-gradient-to-br from-white/70 via-white/40 to-white/10" />
          <div className="relative flex flex-col gap-4 p-5 sm:p-6 md:p-7">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
              <div className="flex items-center gap-4">
                <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-indigo-600/90 text-white shadow-lg">
                  <img alt="" src="/1.png" className="h-10 w-10 rounded-full" />
                </div>
                <div className="min-w-0">
                  <p className="text-lg font-semibold text-gray-900">
                    {training.TrainingDocName}
                  </p>
                  <p className="text-sm text-gray-600">Role: {training.Role || 'General'}</p>
                </div>
              </div>
              <button
                data-component="training-home-course-action"
                data-feature={training.TrainingDocName}
                type="button"
                onClick={() => setStart(training.TrainingDocName)}
                className={`inline-flex items-center justify-center rounded-xl px-5 py-2.5 text-sm font-semibold text-white shadow-md transition-colors ${
                  isFail
                    ? 'bg-rose-600 hover:bg-rose-700'
                    : 'bg-indigo-600 hover:bg-indigo-700'
                }`}
              >
                {isFail ? 'Retake' : 'View'}
              </button>
            </div>

            <div className="flex flex-wrap items-center gap-3">
              {training.isComplete ? (
                <>
                  <div className="flex items-center gap-2 rounded-full bg-indigo-50 px-3 py-1 text-sm font-medium text-indigo-700">
                    <span className="text-gray-500">Score</span>
                    <span className="font-semibold text-gray-900">{training.score} / {training.QuestionNumber}</span>
                  </div>
                  <div
                    className={`rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-wide text-white ${
                      training.difficulty === 'Easy'
                        ? 'bg-emerald-500'
                        : training.difficulty === 'Medium'
                          ? 'bg-amber-500'
                          : 'bg-rose-500'
                    }`}
                  >
                    {training.difficulty || 'Unknown'}
                  </div>
                  <div className="rounded-full bg-slate-900 px-3 py-1 text-xs font-semibold text-white">
                    {scorePercentage}%
                  </div>
                  <div className={`rounded-full px-3 py-1 text-xs font-semibold text-white ${isFail ? 'bg-rose-600' : 'bg-emerald-600'}`}>
                    {isFail ? 'Fail' : 'Pass'}
                  </div>
                </>
              ) : (
                <div className="rounded-full bg-slate-200 px-3 py-1 text-xs font-semibold text-slate-700">
                  Not started yet
                </div>
              )}
            </div>
          </div>
        </li>
      );
    };

    return (
        <>
        {(user.access === 'admin' || user.access === 'manager') ? (
          <ManagerNav />   
        ) : (
          <StaffNav />
        )}
        <div className="min-h-screen bg-gradient-to-br from-indigo-100 via-sky-100 to-white">
          <div data-component='training-home-nav' className='px-3 pt-4 sm:px-6 sm:pt-6'>
            <div className="sm:hidden">
              <label htmlFor="tabs" className="sr-only">
                Select a tab
              </label>
              <select
                data-component='training-home-tab-select'
                id="tabs"
                name="tabs"
                defaultValue={tabs.find((tab) => tab.current).name}
                onChange={(e) => {
                  const selectedTab = tabs.find((tab) => tab.name === e.target.value);
                  if (selectedTab) {
                    window.location.href = selectedTab.href;
                  }
                }}
                className="block w-full rounded-xl border border-white/30 bg-white/70 px-3 py-2 text-sm shadow-md backdrop-blur"
              >
                {tabs.map((tab) => (
                  <option key={tab.name}>{tab.name}</option>
                ))}
              </select>
            </div>
            <div className="hidden sm:block">
              <nav aria-label="Tabs" className="isolate flex divide-x divide-white/30 rounded-2xl bg-white/70 shadow-lg backdrop-blur">
                {tabs.map((tab, tabIdx) => (
                  <a
                    key={tab.name}
                    data-component='training-home-tab'
                    data-feature={tab.name.replace(/\s+/g,'-').toLowerCase()}
                    href={tab.href}
                    aria-current={tab.current ? 'page' : undefined}
                    className={classNames(
                      tab.current ? 'text-indigo-700' : 'text-gray-500 hover:text-gray-700',
                      tabIdx === 0 ? 'rounded-l-2xl' : '',
                      tabIdx === tabs.length - 1 ? 'rounded-r-2xl' : '',
                      'group relative min-w-0 flex-1 overflow-hidden px-4 py-3 text-center text-sm font-semibold hover:bg-white/60 focus:z-10',
                    )}
                  >
                    <span>{tab.name}</span>
                    <span
                      aria-hidden="true"
                      className={classNames(
                        tab.current ? 'bg-indigo-500' : 'bg-transparent',
                        'absolute inset-x-0 bottom-0 h-0.5',
                      )}
                    />
                  </a>
                ))}
              </nav>
            </div>
          </div>

          <div className="px-3 pb-10 pt-6 sm:px-6">
            <div className="mb-6 rounded-3xl border border-white/30 bg-white/60 p-5 shadow-xl backdrop-blur">
              <h2 className="text-xl font-semibold text-gray-900">My Training</h2>
              <p className="text-sm text-gray-600">Courses aligned to your role ({role || 'General'}).</p>
            </div>
            <ul role="list" className="grid grid-cols-1 gap-5">
              {myTraining.length > 0 ? myTraining.map(renderTrainingCard) : (
                <li className="rounded-2xl border border-white/30 bg-white/60 p-5 text-sm text-gray-600 shadow-lg backdrop-blur">
                  No training assigned to your role yet.
                </li>
              )}
            </ul>

            <div className="mt-10 mb-6 rounded-3xl border border-white/30 bg-white/60 p-5 shadow-xl backdrop-blur">
              <h2 className="text-xl font-semibold text-gray-900">Other Courses</h2>
              <p className="text-sm text-gray-600">Additional learning available across the company.</p>
            </div>
            <ul role="list" className="grid grid-cols-1 gap-5">
              {otherTraining.length > 0 ? otherTraining.map(renderTrainingCard) : (
                <li className="rounded-2xl border border-white/30 bg-white/60 p-5 text-sm text-gray-600 shadow-lg backdrop-blur">
                  No other courses available right now.
                </li>
              )}
            </ul>
          </div>
        </div>
        </>
    )
  }
  